export function someGetter(/* state */) {
}
